export default __webpack_public_path__ + "static/media/jebsen-bg.a6d6124b.jpeg";